import { useEffect } from 'react';

export default function LocalSEO({ pageName = '' }) {
  useEffect(() => {
    // Add geo meta tags
    const geoTags = [
      { name: 'geo.region', content: 'US-FL' },
      { name: 'geo.placename', content: 'Trinity' },
      { name: 'geo.position', content: '28.186621;-82.6310909' },
      { name: 'ICBM', content: '28.186621, -82.6310909' },
      { property: 'business:contact_data:locality', content: 'Trinity' },
      { property: 'business:contact_data:region', content: 'FL' },
      { property: 'business:contact_data:postal_code', content: '34655' },
      { property: 'business:contact_data:country_name', content: 'USA' },
      { property: 'business:contact_data:street_address', content: '11105 Trinity Blvd' },
      { property: 'business:contact_data:phone_number', content: '+1-727-228-6846' },
      { property: 'business:contact_data:email', content: 'info@trinitydentalarts.com' }
    ];

    const metaElements = [];

    geoTags.forEach(tag => {
      const existingTag = tag.name 
        ? document.querySelector(`meta[name="${tag.name}"]`)
        : document.querySelector(`meta[property="${tag.property}"]`);
      
      if (!existingTag) {
        const meta = document.createElement('meta');
        if (tag.name) meta.name = tag.name;
        if (tag.property) meta.setAttribute('property', tag.property);
        meta.content = tag.content;
        document.head.appendChild(meta);
        metaElements.push(meta);
      }
    });

    // Add local business keywords as meta keywords
    const keywords = [
      'dentist Trinity FL',
      'dental implants Trinity Florida',
      'cosmetic dentistry Trinity FL',
      'dentist near me Trinity',
      'Trinity Dental Arts',
      'Dr. Xhoana Gjelaj',
      'dental implants near me',
      'New Port Richey dentist',
      'Tampa dentist',
      'Clearwater dentist',
      'All-on-4 dental implants Tampa Bay',
      'emergency dentist Trinity FL',
      'teeth whitening Trinity',
      'porcelain veneers Tampa Bay',
      'general dentistry Pasco County'
    ].join(', ');

    const keywordsTag = document.querySelector('meta[name="keywords"]');
    if (!keywordsTag) {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = keywords;
      document.head.appendChild(meta);
      metaElements.push(meta);
    } else {
      keywordsTag.setAttribute('content', keywords);
    }

    return () => {
      metaElements.forEach(meta => {
        if (meta.parentNode) {
          document.head.removeChild(meta);
        }
      });
    };
  }, [pageName]);

  return null;
}